import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonymous chat home`,
    languageButtonLabel: `Language`,
    languageModalTitle: `Choose a language`,
    languageModalCloseLabel: `Close language menu`,
  },
  languageOptions: {
    'en-US': {
      label: `English (United States)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `English (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `English (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `English (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portuguese (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portuguese (Brazil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `German (Germany)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `German (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `German (Switzerland)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanish (Spain)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `French (France)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italian (Italy)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Dutch (Netherlands)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polish (Poland)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Swedish (Sweden)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danish (Denmark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finnish (Finland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norwegian (Norway)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Icelandic (Iceland)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanese (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Korean (South Korea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarin Chinese (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonese Chinese (Hong Kong)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamese (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesian (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigerian Pidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russian (Russia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabic (Saudi Arabia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabic (United Arab Emirates)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabic (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Moroccan Arabic (Morocco)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe (Turkey)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Choose a language`,
    closeLabel: `Close language menu`,
  },
  languageHint: (ctx) => `Hop across ${ctx.localesCount}+ locales without making an account.`,
  readPagePrompt: ({languageLabel}) => `Read this page in ${languageLabel}.`,
};
